document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('searchInput');
  const categoryFilter = document.getElementById('categoryFilter');
  const articlesContainer = document.getElementById('blogArticles');
  const articles = articlesContainer ? Array.from(articlesContainer.querySelectorAll('.blog-article')) : [];
  const noResultsMessage = document.getElementById('noResultsMessage');
  const resultsCountElement = document.getElementById('blogResultsCount');

  const {
    textForAllArticles = 'Total Articles',
    textForResultsFor = 'Results for:',
    textForResultsInCategory = 'Results in'
  } = window.blogSearchSettings || {};

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  function updateResultsCount(visibleCount, query = '', categoryValue = '', categoryText = '') {
    if (!resultsCountElement) return;

    if (query && query.trim() !== '') {
      resultsCountElement.innerHTML = `<strong>${visibleCount}</strong> ${textForResultsFor} <strong>"${query}"</strong>`;
    } else if (categoryValue && categoryValue.trim() !== '') {
      resultsCountElement.innerHTML = `<strong>${visibleCount}</strong> ${textForResultsInCategory} <strong>"${categoryText}"</strong>`;
    } else {
      resultsCountElement.innerHTML = `<strong>${visibleCount}</strong> ${textForAllArticles}`;
    }
  }

  function filterArticles() {
    if (!articlesContainer) return;

    const query = searchInput ? searchInput.value.toLowerCase().trim() : '';
    const categoryValue = categoryFilter ? categoryFilter.value.toLowerCase().trim() : '';
    const selectedCategoryOption = categoryFilter ? categoryFilter.options[categoryFilter.selectedIndex] : null;
    const categoryText = selectedCategoryOption ? selectedCategoryOption.text : '';

    // Check if we're on a tagged page - if so, don't run the search filter
    const currentPath = window.location.pathname;
    const tagMatch = currentPath.match(/\/tagged\/([^\/]+)/);
    if (tagMatch) {
      console.log('Debug: On tagged page, skipping search filter');
      return; // Don't run search filtering on tagged pages
    }

    // Check if we have API articles available (complete dataset)
    if (window.allBlogArticles && window.allBlogArticles.length > 0) {
      console.log('Debug: Using API articles for search, total:', window.allBlogArticles.length);
      
      // Filter from complete API dataset
      const filteredArticles = window.allBlogArticles.filter(article => {
        const title = (article.title || '').toLowerCase();
        const excerpt = (article.excerpt || '').toLowerCase();
        const tags = (article.tags || []).join(' ').toLowerCase();
        
        const matchesSearch = query === '' || title.includes(query) || excerpt.includes(query) || tags.includes(query);
        const matchesCategory = categoryValue === '' || (tags && tags.includes(categoryValue));
        
        return matchesSearch && matchesCategory;
      });
      
      console.log('Debug: Found', filteredArticles.length, 'articles matching search:', query);
      
      // Replace the display with filtered results
      replaceDisplayWithSearchResults(filteredArticles, query);
      
    } else {
      // Fallback to original Liquid-rendered articles
      console.log('Debug: Using Liquid articles for search, total:', articles.length);
      
      let visibleCount = 0;

      articles.forEach(article => {
        const title = article.getAttribute('data-title') || '';
        const excerpt = article.getAttribute('data-excerpt') || '';
        const tags = article.getAttribute('data-tags') || '';

        const matchesSearch = query === '' || title.includes(query) || excerpt.includes(query);
        const matchesCategory = categoryValue === '' || (tags && tags.includes(categoryValue));

        if (matchesSearch && matchesCategory) {
          article.style.display = 'block';
          visibleCount++;
        } else {
          article.style.display = 'none';
        }
      });

      if (noResultsMessage) {
        noResultsMessage.style.display = visibleCount === 0 ? 'block' : 'none';
      }
      if (articlesContainer) {
        articlesContainer.style.display = visibleCount > 0 ? 'block' : 'none';
      }

      updateResultsCount(visibleCount, query, categoryValue, categoryText);
    }
    
    // If search is cleared, restore original display
    if (query === '') {
      restoreOriginalDisplay();
      fetchRealArticleCount();
    }
  }
  
  // Function to replace display with search results
  function replaceDisplayWithSearchResults(filteredArticles, searchQuery) {
    if (!articlesContainer) return;
    
    console.log('Debug: Replacing display with search results');
    
    // Update results count
    updateResultsCount(filteredArticles.length, searchQuery);
    
    // Clear current display
    articlesContainer.innerHTML = '';
    
    // Hide no results message
    if (noResultsMessage) {
      noResultsMessage.style.display = 'none';
    }
    
    if (filteredArticles.length > 0) {
      // Create and display filtered articles
      filteredArticles.forEach(article => {
        const articleHtml = `
          <div class="blog-article"
            data-title="${(article.title || '').toLowerCase().replace(/"/g, '&quot;')}"
            data-excerpt="${(article.excerpt || '').toLowerCase().replace(/"/g, '&quot;')}"
            data-tags="${(article.tags || []).join(' ').toLowerCase()}">
            <h2><a href="/blogs/mcr-medical-blog/${article.handle}">${article.title}</a></h2>
            ${article.excerpt ? `<div class="article-excerpt"><p>${article.excerpt}</p></div>` : ''}
            <div class="blog-meta">
              <span>${new Date(article.publishedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
              <span>0 comments</span>
            </div>
          </div>
        `;
        articlesContainer.insertAdjacentHTML('beforeend', articleHtml);
      });
      
      articlesContainer.style.display = 'block';
      
      // Hide pagination since we're showing search results
      const paginationContainer = document.getElementById('customPagination');
      if (paginationContainer) {
        paginationContainer.style.display = 'none';
      }
      
    } else {
      // Show no results message
      articlesContainer.innerHTML = `
        <div class="no-tagged-articles">
          <p>No articles found matching "${searchQuery}".</p>
          <a href="/blogs/mcr-medical-blog" class="back-to-all">← Back to all articles</a>
        </div>
      `;
      
      // Hide pagination
      const paginationContainer = document.getElementById('customPagination');
      if (paginationContainer) {
        paginationContainer.style.display = 'none';
      }
    }
  }
  
  // Function to restore original display
  function restoreOriginalDisplay() {
    if (!articlesContainer) return;
    
    console.log('Debug: Restoring original display');
    
    // Show all original articles
    const allArticles = articlesContainer.querySelectorAll('.blog-article');
    allArticles.forEach(article => {
      article.style.display = 'block';
    });
    
    // Show pagination
    const paginationContainer = document.getElementById('customPagination');
    if (paginationContainer) {
      paginationContainer.style.display = 'block';
    }
    
    // Hide no results message
    if (noResultsMessage) {
      noResultsMessage.style.display = 'none';
    }
    
    // Show articles container
    articlesContainer.style.display = 'block';
    
    // Update results count to show total
    if (resultsCountElement) {
      resultsCountElement.innerHTML = `<strong>${allArticles.length}</strong> Total Articles`;
    }
  }
  
  // Function to fetch real article count via API
  async function fetchRealArticleCount() {
    const currentPath = window.location.pathname;
    const blogMatch = currentPath.match(/^\/blogs\/([^\/]+)/);
    if (!blogMatch) return;
    
    const blogHandle = blogMatch[1];
    const token = '9d9ca46f8ed92d852fe923e18a1c52c5'; // Replace with your actual token
    
    try {
      let allArticles = [];
      let hasNextPage = true;
      let endCursor = null;
      
      while (hasNextPage) {
        const query = `
          query {
            blog(handle: "${blogHandle}") {
              articles(first: 250, sortKey: PUBLISHED_AT, reverse: true${endCursor ? `, after: "${endCursor}"` : ''}) {
                pageInfo {
                  hasNextPage
                  endCursor
                }
                edges {
                  node {
                    title
                    handle
                    excerpt
                    tags
                  }
                }
              }
            }
          }
        `;
        
        const res = await fetch('/api/2025-07/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({query})
        });
        
        const json = await res.json();
        
        if (json.data && json.data.blog && json.data.blog.articles) {
          const articles = json.data.blog.articles.edges.map(edge => edge.node);
          allArticles = allArticles.concat(articles);
          
          hasNextPage = json.data.blog.articles.pageInfo.hasNextPage;
          endCursor = json.data.blog.articles.pageInfo.endCursor;
        } else {
          hasNextPage = false;
        }
      }
      
      // Update the results count with real total
      const resultsCountElement = document.getElementById('blogResultsCount');
      if (resultsCountElement) {
        resultsCountElement.innerHTML = `<strong>${allArticles.length}</strong> Total Articles`;
        console.log('Debug: Updated results count to real total:', allArticles.length);
      }
      
    } catch (error) {
      console.error('Error fetching real article count:', error);
    }
  }

  const isArticlePage = window.location.pathname.match(/^\/blogs\/[^\/]+\/[^\/]+$/);
  if (isArticlePage && searchInput) {
    searchInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        const query = searchInput.value.trim();
        if (query !== '') {
          window.location.href = `/blogs/mcr-medical-blog?search=${encodeURIComponent(query)}`;
        }
      }
    });
  }
  
  // Add Enter key functionality for tagged pages
  const isTaggedPage = window.location.pathname.match(/\/tagged\/([^\/]+)/);
  if (isTaggedPage && searchInput) {
    searchInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        const query = searchInput.value.trim();
        if (query !== '') {
          const blogHandle = 'mcr-medical-blog'; // Hardcoded to fix redirect issue
          const mainBlogUrl = `/blogs/${blogHandle}?search=${encodeURIComponent(query)}`;
          window.location.href = mainBlogUrl;
        }
      }
    });
  }

  const urlParams = new URLSearchParams(window.location.search);
  const searchParam = urlParams.get('search');
  if (searchInput && searchParam) {
    searchInput.value = decodeURIComponent(searchParam);
    console.log('Debug: Search parameter found:', searchParam);
    
    // Set a flag to run search after API loads
    window.runSearchAfterLoad = searchParam;
    console.log('Debug: Set search flag for after API load:', searchParam);
  }

  if (!isArticlePage) {
    if (searchInput) {
      searchInput.addEventListener('input', debounce(function () {
        // Check if we're on a tagged page - if so, redirect to main blog with search
        const currentPath = window.location.pathname;
        const tagMatch = currentPath.match(/\/tagged\/([^\/]+)/);
        if (tagMatch) {
          const query = searchInput.value.trim();
          if (query.length > 0) {
            console.log('Debug: On tagged page, redirecting to main blog with search:', query);
            // Redirect to main blog page with search parameter
            const blogHandle = 'mcr-medical-blog'; // Hardcoded to fix redirect issue
            const mainBlogUrl = `/blogs/${blogHandle}?search=${encodeURIComponent(query)}`;
            window.location.href = mainBlogUrl;
          }
          return;
        }
        
        filterArticles();
        const query = searchInput.value.trim();

        if (query === '') {
          const url = new URL(window.location.href);
          url.searchParams.delete('search');
          window.history.replaceState({}, '', url.pathname);
          
          // When search is cleared, fetch real article count
          console.log('Debug: Search cleared, fetching real article count');
          fetchRealArticleCount();
        }
      }, 300));
    }
    
    // Handle category filter change - redirect to tagged URL instead of client-side filtering
    if (categoryFilter) {
      categoryFilter.addEventListener('change', function() {
        const selectedValue = this.value;
        if (selectedValue && selectedValue.trim() !== '') {
          // Get the current blog URL and construct the tagged URL
          const currentPath = window.location.pathname;
          const blogMatch = currentPath.match(/^\/blogs\/([^\/]+)/);
          if (blogMatch) {
            const blogHandle = blogMatch[1];
            const taggedUrl = `/blogs/${blogHandle}/tagged/${selectedValue}`;
            window.location.href = taggedUrl;
          }
        } else {
          // If "Categories" is selected, go to main blog page
          const currentPath = window.location.pathname;
          const blogMatch = currentPath.match(/^\/blogs\/([^\/]+)/);
          if (blogMatch) {
            const blogHandle = blogMatch[1];
            window.location.href = `/blogs/${blogHandle}`;
          }
        }
      });
    }
    
    // Update results count on page load for tag filtering
    if (resultsCountElement) {
      const currentPath = window.location.pathname;
      const tagMatch = currentPath.match(/\/tagged\/([^\/]+)/);
      
      if (tagMatch) {
        const tagName = decodeURIComponent(tagMatch[1]);
        // Don't override the count on tagged pages - let the API handle it
        console.log('Debug: On tagged page, not overriding results count');
      } else {
        const articles = articlesContainer ? Array.from(articlesContainer.querySelectorAll('.blog-article')) : [];
        resultsCountElement.innerHTML = `<strong>${articles.length}</strong> Total Articles`;
      }
    }
    
    if (articles.length > 0) {
      // Check if we're on a tagged page - if so, don't run the initial filter
      const currentPath = window.location.pathname;
      const tagMatch = currentPath.match(/\/tagged\/([^\/]+)/);
      if (tagMatch) {
        console.log('Debug: On tagged page, skipping initial filter');
      } else {
        filterArticles();
      }
    } else if (resultsCountElement) {
      updateResultsCount(0);
      if (noResultsMessage) noResultsMessage.style.display = 'block';
      if (articlesContainer) articlesContainer.style.display = 'none';
    }
  }
});

